import dhtmlXGridObject from './dhtmlXGridObject';

/**
 * 添加一行数据到表格中
 * @param new_id row ID, must be unique
 * @param text row values, may be a comma-separated list or an array
 * @param ind 新行的索引，默认情况下将行添加到最后一个位置
 * @param parent_id id of the parent row
 * @param img img url for new row
 * @param child child flag (optional)
 */
dhtmlXGridObject.prototype.addRow = function (new_id, text, ind, parent_id, img, child) {
    if (!this._h2) {
        return this._addRowClassic(new_id, text, ind);
    }
    parent_id = parent_id || 0;
    // var e = this.cellType._dhx_find("tree");
    if (typeof text == "string") {
        text = text.split(this.delim);
    }
    var l = this._h2.get[new_id];
    if (!l) {
        if (parent_id == 0) {
            ind = this.rowsBuffer.length;
        }
        else {
            ind = this.getRowIndex(parent_id) + 1;
            if (this._h2.get[parent_id].state == "minus") {
                ind += this._getOpenLenght(parent_id, 0);
            }
            else {
                this._skipInsert = true;
            }
        }
    }
    l = l || this._h2.add(new_id, parent_id);
    l.image = img;
    l.has_kids = child;
    return (l.buff = this._addRowClassic(new_id, text, ind));
};
/**
 * 在表格中添加数据 在指定行前插入
 * @param new_id row ID, must be unique
 * @param text row values, may be a comma-separated list or an array
 * @param sibl_id 指定行id
 * @param img
 * @param child
 */
dhtmlXGridObject.prototype.addRowBefore = function (new_id, text, sibl_id, img, child) {
    var m = this.rowsAr[sibl_id];
    if (!m) {
        return;
    }
    if (!this._h2) {
        return this.addRow(new_id, text, this.getRowIndex(sibl_id));
    }
    var a = this._h2.get[sibl_id].parent.id;
    var h = this.getRowIndex(sibl_id);
    if (h == -1) {
        this._skipInsert = true;
    }
    this._h2.addBefore(new_id, a, sibl_id);
    return this.addRow(new_id, text, h, this._h2.get[sibl_id].parent.id, img, child);
};
/**
 * 在表格中添加数据 在指定行后插入
 * @param new_id row ID, must be unique
 * @param text row values, may be a comma-separated list or an array
 * @param sibl_id 指定行id
 * @param img
 * @param child
 */
dhtmlXGridObject.prototype.addRowAfter = function (new_id, text, sibl_id, img, child) {
    var m = this.rowsAr[sibl_id];
    if (!m) {
        return;
    }
    if (!this._h2) {
        return this.addRow(new_id, text, this.getRowIndex(sibl_id) + 1);
    }
    var a = this._h2.get[sibl_id].parent.id;
    var h = this.getRowIndex(sibl_id);
    if (h == -1) {
        this._skipInsert = true;
    }
    if (this._h2.get[sibl_id].state == "minus") {
        h += this._getOpenLenght(sibl_id, 0) + 1;
    }
    else {
        h++;
    }
    this._h2.addAfter(new_id, a, sibl_id);
    return this.addRow(new_id, text, h, a, img, child);
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/goingTreeGridMethods.js